import { createSuggestionsActions, removeSpecialChars } from 'client/common/suggestionsActions'

export const GET_SUGGESTIONS_SUCCESS = 'GET_SUGGESTIONS_SUCCESS'
export { removeSpecialChars }

export const { onSuggestionsChange } = createSuggestionsActions(GET_SUGGESTIONS_SUCCESS)
